(function () {
    var cartQueue = [];
    
    var masterProducts = ['UP-WHT', 'UP-BLK', 'UP-PLUS-7032M', 'UP-PLUS-7035G', 'UP-PLUS-1015G', 'UP-PLUS-9010M', 'UP-PLUS-9016G', 'UP-PLUS-1019M',
                          'UP-PLUS-7042M', 'UP-PREM-CA9022', 'UP-PREM-149/90500', 'UP-PREM-230/51120', 'UP-PREM-38/20014',
                          'UP-PREM-38/15018', 'UP-PREM-61/68002', 'UP-PREM-418/41218', 'UP-PREM-139/40010', 'UP-PREM-5019G', 'UP-PREM-138/91036',  
                          'UP-PREM-6002M', 'UP-PREM-6037G', 'UP-PREM-6002M', 'UP-PREM-6002G', 'UP-PREM-1018M', 'UP-PREM-1016G',  'UP-PREM-3031G',
                          'UP-PREM-3015G', 'UP-PREM-4005G', 'UP-PREM-2009G', 'UP-CUSTOM',
                          'UP-PREM-3020M', 'UP-PREM-3020G', 'UP-GREY','UP-BLK-CUSTOM'];
    var activeCartProcess;

    function generateUUID() { // Public Domain/MIT
        var d = new Date().getTime(); //Timestamp
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16; //random number between 0 and 16
            if (d > 0) { //Use timestamp until depleted
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else { //Use microseconds since page-load if supported
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    function setMasterProduct(addJsResponse, data, groupUUID) {
        // Reset properties
        const configurationSKU = addJsResponse.properties['Configuration SKU'];
        const configurationLink = addJsResponse.properties['Configuration Link'];
        delete addJsResponse.properties['Configuration SKU'];
        delete addJsResponse.properties['Configuration Link'];
        

        const shopifyLocale = Shopify.locale || 'en';

        addJsResponse.properties = Object.assign(addJsResponse.properties, {
            _configuration_sku: configurationSKU,
            _customizer_group_id: groupUUID,
            _preview_image: data.thumbnail, // Dynamic
            _customizer_master: true, // Fixed
            _configuration_link: `https://${configurationLink}&locale=${shopifyLocale}`,
        });

        // Set master product
        if (!data.hasOwnProperty('variant_ids')) {
            throw new Error('variant not fount');
        }

        const configuredProduct = data.configuredProduct;

        const masterDummy = configuredProduct.articles.find(function (item) {
            return masterProducts.includes(item.price_sku);
        });

        if (!masterDummy) {
            return;
        }

        addJsResponse.quantity = 1;

        addJsResponse.id = data.variant_ids[masterDummy.price_sku];

        // Remove the master, so we can add all other items later
        delete data.variant_ids[masterDummy.price_sku];
    }

    // Note: shopify doesn't allow simultaneous calls to add.js, so we build a queue
    function processQueue() {
        if (activeCartProcess || cartQueue.length === 0) {
            return;
        }

        activeCartProcess = cartQueue.shift();
        $.post('/cart/add.js', activeCartProcess.data, null, 'json').done(function () {
            activeCartProcess.readyCallback();
        }).fail(function () {
            activeCartProcess.failCallback();
        }).always(function () {
            activeCartProcess = null;
            processQueue();
        });
    }

    function addProductToCart(data) {
        return new Promise(function (resolve, reject) {
            cartQueue.push({
                data: data,
                readyCallback: resolve,
                failCallback: reject
            });

            processQueue();
        });
    }

    function addMasterProductToCart(addJsResponse) {
        return addProductToCart(addJsResponse);
    }

    function addSubSequentProductsToCart(data, groupUUID) {
        return new Promise(function (resolve, reject) {
            const configuredProduct = data.configuredProduct;

            if (!configuredProduct || !Array.isArray(configuredProduct.articles)) {
                reject();
            }

            const addPromises = [];

            configuredProduct.articles.forEach(function (model) {
                if (!(model.models_sku in data.variant_ids) || !data.variant_ids[model.models_sku]) {
                    return;
                }

                const searchParams = new URLSearchParams(window.location.search);
                const quantity = configuredProduct.articles.reduce((a, c) => {
                  return a + (c.models_sku === model.models_sku ? 1 : 0);
                }, 0);

                const addToCart = addProductToCart({
                    "id": data.variant_ids[model.models_sku],
                    "quantity": quantity,
                    "properties": {
                        "_customizer_group_id": groupUUID,
                    }
                });

                addPromises.push(addToCart);

                // Remove from list so it doesn't get re-added
                delete data.variant_ids[model.models_sku];
            });

            Promise.all(addPromises).then(function () {
                resolve();
            }, function () {
                reject();
            });
        });
    }

    function enableAddToCart() {
        const $button = $('button.expivi-add-to-cart');

        $button.removeAttr('disabled');
        $button.removeClass('loading');
    }

    function addToCart(resolve, reject, addJsResponse, data) {
        const groupUUID = generateUUID();

        try {
            setMasterProduct(addJsResponse, data, groupUUID);
        } catch (err) {
            enableAddToCart();
            return;
        }

        Promise.all([
            addMasterProductToCart(addJsResponse),
            addSubSequentProductsToCart(data, groupUUID)
        ]).finally(function () {
            enableAddToCart();
            window.location.href = '/cart';
        });
    }

    window.expiviCartAfterStore = function (resolve, reject, addJsResponse, data) {
        data.dpi = data.dpi || 300;
        addToCart(resolve, reject, addJsResponse, data);
    };
})();